var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"margin-bottom":"0px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"Issues"},[_c('div',{staticClass:"columns Issues-container is-multiline",style:({ marginBottom: 44 + 'px', display: 'flex' })},_vm._l((_vm.issues),function(issue){return _c('issue-card',{key:issue.id,attrs:{"issue":issue}})}))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfaec996","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=slm&optionsId=0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FrontpageIssueList.vue
// module id = 498
// module chunks = 1